(function($, Drupal)
{
    Drupal.behaviors.slick_slider = {
        attach:function() {

            $('.prozessSlider').slick({
                infinite: true,
                dots: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [

                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 776,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

        }
    };
}(jQuery, Drupal));
